import { render, staticRenderFns } from "./UserFollowButton.vue?vue&type=template&id=07c5973e"
import script from "./UserFollowButton.vue?vue&type=script&lang=js"
export * from "./UserFollowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports